module.exports = __webpack_public_path__ + "media/src/images/favicon/mstile-150x150-d1e9a0527116b7cb887eb74152ee1394.png";